import React from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import { injectIntl } from "react-intl";

const ContentMultiForm = (props) => {
  const { data, intl } = props;
  // console.log(data);
  const columns = [
    {
      Header: intl.formatMessage({ id: "stock.header.material_name" }),
      accessor: "name",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({ id: "stock.header.unit" }),
      accessor: "unit",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({ id: "stock.header.total_import" }),
      accessor: "total",
    },
    {
      Header: intl.formatMessage({ id: "stock.header.new_quantity" }),
      accessor: "income",
    },
    {
      Header: intl.formatMessage({ id: "stock.header.inventory" }),
      accessor: "count",
    },
    {
      Header: intl.formatMessage({ id: "stock.header.below_20" }),
      accessor: "is_alert_down_20",
      Cell: (props) =>
        props.value === true
          ? intl.formatMessage({ id: "stock.header.true" })
          : intl.formatMessage({ id: "stock.header.false" }),
    },
    {
      Header: intl.formatMessage({ id: "stock.header.below_10" }),
      accessor: "is_alert_down_10",
      Cell: (props) =>
        props.value === true
          ? intl.formatMessage({ id: "stock.header.true" })
          : intl.formatMessage({ id: "stock.header.false" }),
    },
  ];
  const scrollRef = React.useRef(null);

  React.useEffect(() => {
    const handleWheel = (e) => {
      if (e.deltaY !== 0) {
        const container = scrollRef.current?._container || scrollRef.current;
        if (container) {
          container.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }
    };

    const container = scrollRef.current?._container || scrollRef.current;
    if (container && container.addEventListener) {
      container.addEventListener("wheel", handleWheel, { passive: false });
    }

    return () => {
      if (container && container.removeEventListener) {
        container.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);

  return (
    <div className="table-responsive">
      <PerfectScrollbar
        ref={scrollRef}
        options={{ suppressScrollX: false, suppressScrollY: false }}
        style={{ width: "100%", border: "1px solid #ebebeb" }}
      >
        <div style={{ minWidth: "100%", width: "max-content" }}>
          <ReactTable
            defaultPageSize={20}
            data={data}
            columns={columns}
            minRows={0}
            showPageJump={false}
            showPageSizeOptions={true}
            PaginationComponent={Pagination}
            NoDataComponent={() => null}
          />
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default injectIntl(ContentMultiForm);
